import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
    const location = useLocation();

    // Split path into segments and filter out empty strings
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');

    // Map segment names to readable labels
    const getBreadcrumbName = (segment, index) => {
        // Static mappings
        const mapping = {
            'admin': 'Dashboard',
            'analytics': 'Analytics',
            'brands': 'Brands',
            'conversations': 'Conversations',
            'inventory': 'Inventory',
            'users': 'Users'
        };

        if (mapping[segment]) return mapping[segment];

        // Heuristic for IDs: 24-char hex string usually (MongoDB)
        if (segment.length === 24 && /^[0-9a-fA-F]{24}$/.test(segment)) {
            return 'Details';
        }

        // Fallback: capitalize first letter
        return segment.charAt(0).toUpperCase() + segment.slice(1);
    };

    return (
        <nav aria-label="breadcrumb" className="mb-4">
            <ol className="breadcrumb">
                {pathSegments.map((segment, index) => {
                    const isLast = index === pathSegments.length - 1;
                    const to = `/${pathSegments.slice(0, index + 1).join('/')}`;
                    const name = getBreadcrumbName(segment, index);

                    return isLast ? (
                        <li key={to} className="breadcrumb-item active" aria-current="page">
                            {name}
                        </li>
                    ) : (
                        <li key={to} className="breadcrumb-item">
                            <Link to={to} className="text-decoration-none">{name}</Link>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;
